export default __webpack_public_path__ + "static/media/Gebouwen.f7819cf5.svg";